/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type { CamelToSnake } from "../../wire/transform";
import type {
  CreateAlmConnectionRequest,
  CreateAlmConnectionResponse,
  GetAlmConnectionsResponse,
  GetAlmToolsResponse,
  GetAlmTypeResponse,
  GetArtMappingSourcesResponse,
  GetCertificateInfoResponse,
  GetDisableDeleteResponse,
  GetIgnoreWebhooksFiredByAlmUserResponse,
  GetNameResponse,
  GetSessionInfoResponse,
  GetTeamMappingSourcesResponse,
  GetTimeoutResponse,
  GetTlsVerificationResponse,
  GetUrlResponse,
  NoData,
  SetArtMappingSourcesRequest,
  SetCertificateRequest,
  SetDisableDeleteRequest,
  SetIgnoreWebhooksFiredByAlmUserRequest,
  SetNameRequest,
  SetPassphraseRequest,
  SetTeamMappingSourcesRequest,
  SetTimeoutRequest,
  SetTlsVerificationRequest,
  SetUrlRequest,
} from "./models";
import {
  createAlmConnectionResponseSchema,
  getAlmConnectionsResponseSchema,
  getAlmToolsResponseSchema,
  getAlmTypeResponseSchema,
  getArtMappingSourcesResponseSchema,
  getDisableDeleteResponseSchema,
  getIgnoreWebhooksFiredByAlmUserResponseSchema,
  getNameResponseSchema,
  getSessionInfoResponseSchema,
  getTeamMappingSourcesResponseSchema,
  getTimeoutResponseSchema,
  getTlsVerificationResponseSchema,
  getUrlResponseSchema,
  noDataSchema,
} from "./schemas";

export class AlmconnectionCommonApiClient {
  constructor(private caller: ApiCaller) {}

  async getConnections(timeout?: number): Promise<GetAlmConnectionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.get",
        variables: {},
      },
      "getConnections",
      {},
      { schema: getAlmConnectionsResponseSchema, timeout },
    );
  }

  async createConnection(
    payload: CreateAlmConnectionRequest,
    timeout?: number,
  ): Promise<CreateAlmConnectionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.create",
        variables: {},
      },
      "createConnection",
      payload,
      { schema: createAlmConnectionResponseSchema, timeout },
    );
  }

  async getSession(sessionId: string, timeout?: number): Promise<GetSessionInfoResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.sessions.${sessionId}.get",
        variables: { sessionId: String(sessionId) },
      },
      "getSession",
      {},
      { schema: getSessionInfoResponseSchema, timeout },
    );
  }

  async getAlmTools(timeout?: number): Promise<GetAlmToolsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.alm_tools.get",
        variables: {},
      },
      "getAlmTools",
      {},
      { schema: getAlmToolsResponseSchema, timeout },
    );
  }

  async getName(connectionId: string, timeout?: number): Promise<GetNameResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.names.get",
        variables: { connectionId: String(connectionId) },
      },
      "getName",
      {},
      { schema: getNameResponseSchema, timeout },
    );
  }

  async setName(payload: SetNameRequest, connectionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.names.set",
        variables: { connectionId: String(connectionId) },
      },
      "setName",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getUrl(connectionId: string, timeout?: number): Promise<GetUrlResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.urls.get",
        variables: { connectionId: String(connectionId) },
      },
      "getUrl",
      {},
      { schema: getUrlResponseSchema, timeout },
    );
  }

  async setUrl(payload: SetUrlRequest, connectionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.urls.set",
        variables: { connectionId: String(connectionId) },
      },
      "setUrl",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getTimeout(connectionId: string, timeout?: number): Promise<GetTimeoutResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.timeouts.get",
        variables: { connectionId: String(connectionId) },
      },
      "getTimeout",
      {},
      { schema: getTimeoutResponseSchema, timeout },
    );
  }

  async setTimeout(
    payload: SetTimeoutRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.timeouts.set",
        variables: { connectionId: String(connectionId) },
      },
      "setTimeout",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getTlsVerification(
    connectionId: string,
    timeout?: number,
  ): Promise<GetTlsVerificationResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.tls_verifications.get",
        variables: { connectionId: String(connectionId) },
      },
      "getTlsVerification",
      {},
      { schema: getTlsVerificationResponseSchema, timeout },
    );
  }

  async setTlsVerification(
    payload: SetTlsVerificationRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.tls_verifications.set",
        variables: { connectionId: String(connectionId) },
      },
      "setTlsVerification",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getDisableDelete(
    connectionId: string,
    timeout?: number,
  ): Promise<GetDisableDeleteResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.disable_delete.get",
        variables: { connectionId: String(connectionId) },
      },
      "getDisableDelete",
      {},
      { schema: getDisableDeleteResponseSchema, timeout },
    );
  }

  async setDisableDelete(
    payload: SetDisableDeleteRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.disable_delete.set",
        variables: { connectionId: String(connectionId) },
      },
      "setDisableDelete",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async setCertificate(
    payload: SetCertificateRequest,
    connectionId: string,
    certificateId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.certificates.${certificateId}.set",
        variables: { connectionId: String(connectionId), certificateId: String(certificateId) },
      },
      "setCertificate",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteCertificate(
    connectionId: string,
    certificateId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.certificates.${certificateId}.delete",
        variables: { connectionId: String(connectionId), certificateId: String(certificateId) },
      },
      "deleteCertificate",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getCertificateInfo(
    connectionId: string,
    certificateId: string,
    timeout?: number,
  ): Promise<CamelToSnake<GetCertificateInfoResponse>> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.certificates.${certificateId}.info.get",
        variables: { connectionId: String(connectionId), certificateId: String(certificateId) },
      },
      "getCertificateInfo",
      {},
      { timeout },
    );
  }

  async setPassphrase(
    payload: SetPassphraseRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.tls_client_cert_passphrases.set",
        variables: { connectionId: String(connectionId) },
      },
      "setPassphrase",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getArtMappingSources(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetArtMappingSourcesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.arts.${artId}.mapping_sources.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getArtMappingSources",
      {},
      { schema: getArtMappingSourcesResponseSchema, timeout },
    );
  }

  async setArtMappingSources(
    payload: SetArtMappingSourcesRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.arts.${artId}.mapping_sources.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setArtMappingSources",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getTeamMappingSources(
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<GetTeamMappingSourcesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.teams.${teamId}.mapping_sources.get",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "getTeamMappingSources",
      {},
      { schema: getTeamMappingSourcesResponseSchema, timeout },
    );
  }

  async setTeamMappingSources(
    payload: SetTeamMappingSourcesRequest,
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.teams.${teamId}.mapping_sources.set",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "setTeamMappingSources",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getIgnoreWebhooksFiredByAlmUser(
    connectionId: string,
    timeout?: number,
  ): Promise<GetIgnoreWebhooksFiredByAlmUserResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.ignore_webhooks_fired_by_alm_user.get",
        variables: { connectionId: String(connectionId) },
      },
      "getIgnoreWebhooksFiredByAlmUser",
      {},
      { schema: getIgnoreWebhooksFiredByAlmUserResponseSchema, timeout },
    );
  }

  async setIgnoreWebhooksFiredByAlmUser(
    payload: SetIgnoreWebhooksFiredByAlmUserRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.ignore_webhooks_fired_by_alm_user.set",
        variables: { connectionId: String(connectionId) },
      },
      "setIgnoreWebhooksFiredByAlmUser",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAlmType(connectionId: string, timeout?: number): Promise<GetAlmTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.alm_type.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAlmType",
      {},
      { schema: getAlmTypeResponseSchema, timeout },
    );
  }

  async deleteConnection(connectionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.connections.${connectionId}.delete",
        variables: { connectionId: String(connectionId) },
      },
      "deleteConnection",
      {},
      { schema: noDataSchema, timeout },
    );
  }
}
